import { splitMarkdownLinks } from "@/lib/apps/autoleads/markdown-links"

// A drafted body with its Markdown links shown as the prospect sees them: the
// anchor, clickable. The surrounding element keeps its own whitespace rule.
export function LinkedBody({ body }: { body: string }) {
  return (
    <>
      {splitMarkdownLinks(body).map((part, index) =>
        part.kind === "link" ? (
          <a
            key={index}
            href={part.url}
            target="_blank"
            rel="noreferrer"
            className="text-primary underline underline-offset-2"
          >
            {part.text}
          </a>
        ) : (
          <span key={index}>{part.text}</span>
        ),
      )}
    </>
  )
}
